<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <v-container class="px-6">
    <page-header>
      {{ $t('exportAndPrint') }}
    </page-header>

    <v-card
      class="mt-4 py-4 px-2 font-weight-regular"
      elevation="0"
    >
      <div class="text-h4 font-weight-bold">
        {{ $t('exportData') }}
      </div>
      <div class="mt-8">
        <p>{{ $t('aadenPosSupportTitle') }}</p>
        <p v-html="$t('aadenPosExportDesc')"/>
      </div>
      <div class="text-h4 font-weight-bold mt-8">
        {{ $t('selectDataToExport') }}
      </div>
      <div
        class="mt-4"
        @click="scrollToBottom"
      >
        <v-item-group
          v-model="tab"
          mandatory
        >
          <div class="d-flex">
            <v-item v-slot="{active,toggle}">
              <v-btn
                :color="active?'primary':''"
                :outlined="!active"
                class="mr-2"
                rounded
                small
                @click="toggle"
              >
                {{ $t('totalOrders') }}
              </v-btn>
            </v-item>
            <v-item v-slot="{active,toggle}">
              <v-btn
                :color="active?'primary':''"
                :outlined="!active"
                class="mr-2"
                rounded
                small
                @click="toggle"
              >
                {{ $t('zbon') }}
              </v-btn>
            </v-item>
            <v-item v-slot="{active,toggle}">
              <v-btn
                :color="active?'primary':''"
                :outlined="!active"
                class="mr-2"
                rounded
                small
                @click="toggle"
              >
                {{ $t('datevCsv') }}
              </v-btn>
            </v-item>
            <v-item v-slot="{active,toggle}">
              <v-btn
                :color="active?'primary':''"
                :outlined="!active"
                class="mr-2"
                rounded
                small
                @click="toggle"
              >
                {{ $t('gdpduCsv') }}
              </v-btn>
            </v-item>
            <v-item v-slot="{active,toggle}">
              <v-btn
                :color="active?'primary':''"
                :outlined="!active"
                rounded
                small
                @click="toggle"
              >
                {{ $t('salesBon') }}
              </v-btn>
            </v-item>
          </div>
        </v-item-group>
      </div>

      <v-card
        class="mt-4"
        outlined
      >
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <xbon-export/>
          </v-tab-item>
          <v-tab-item>
            <zbon-export/>
          </v-tab-item>
          <v-tab-item>
            <datev/>
          </v-tab-item>
          <v-tab-item>
            <g-d-pd-u-c-s-v-export/>
          </v-tab-item>
          <v-tab-item>
            <dish-statistic/>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
  import ZbonExport from '@/views/AadenPages/export/childPage/ZbonExportFragment'
  import GDPdUCSVExport from '@/views/AadenPages/export/childPage/GDPdUCSVExportFragment'
  import Datev from '@/views/AadenPages/export/childPage/DatevSettingFragment'
  import DishStatistic from '@/views/AadenPages/export/childPage/DishStatisticFragment'
  import PageHeader from '@/composable/InK/typography/PageHeader'
  import XbonExport from '@/views/AadenPages/export/childPage/XBonExportFragment'

  export default {
    name: 'ExportPage',
    components: {
      XbonExport,
      PageHeader,
      DishStatistic,
      Datev,
      GDPdUCSVExport,
      ZbonExport,
    },
    data: function () {
      return {
        tab: null,
      }
    },
    methods: {
      scrollToBottom () {
        setTimeout(() => {
          this.$vuetify.goTo(9999)
        }, 200)
      },
    },
  }
</script>

<style scoped>

</style>
